// extracted by mini-css-extract-plugin
export default {"rank":"useColumns_rank__gj6oc","crown":"useColumns_crown__qcpgu","rankDiff":"useColumns_rankDiff__Pkfc4","avatar":"useColumns_avatar__4V71e"};